import { Globe, ExternalLink, Calendar } from 'lucide-react';

export default function PagesTab({ store, domainConfig }) {
    return (
        <div className="p-8 space-y-8">
            {/* Header */}
            <div className="bg-gradient-to-r from-slate-50 to-slate-100/80 rounded-2xl p-6 border border-slate-200/60">
                <h3 className="text-2xl font-bold text-slate-900 flex items-center gap-3">
                    <div className="p-2 bg-white rounded-xl shadow-sm border border-slate-200/60">
                        <Globe size={24} className="text-slate-700" />
                    </div>
                    All Pages
                </h3>
                <p className="text-slate-600 mt-2 font-medium">Complete page inventory organized by domain</p>
            </div>

            <div className="space-y-8">
                {Object.entries(store.pages.reduce((acc, page) => {
                    if (!acc[page.domain]) acc[page.domain] = [];
                    acc[page.domain].push(page);
                    return acc;
                }, {})).map(([domain, pages]) => {
                    const config = domainConfig[domain];
                    return (
                        <div key={domain} className="bg-white rounded-2xl p-8 border border-slate-200/60 shadow-sm">
                            {/* Domain Header */}
                            <div className={`flex items-center gap-4 px-6 py-4 rounded-2xl border-2 mb-6 ${config.bgColor} ${config.borderColor}`}>
                                <div className={`p-3 bg-white rounded-xl border border-slate-200/60 ${config.color}`}>
                                    {config.icon}
                                </div>
                                <div className="flex-1">
                                    <h3 className={`font-bold text-2xl ${config.color}`}>
                                        {domain} Domain
                                    </h3>
                                    <p className="text-slate-600 font-medium">
                                        {pages.length} page{pages.length !== 1 ? 's' : ''} in this domain
                                    </p>
                                </div>
                                <div className={`px-4 py-2 rounded-full text-lg font-bold ${config.bgColor} ${config.color} border ${config.borderColor}`}>
                                    {pages.length}
                                </div>
                            </div>

                            {/* Pages in this domain */}
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                                {pages.map((page, index) => (
                                    <div
                                        key={`${page.domain}-${page.type}`}
                                        className="bg-gradient-to-br from-slate-50 to-slate-100/50 rounded-2xl p-6 border border-slate-200/60 hover:shadow-md transition-all duration-200"
                                    >
                                        <div className="flex items-center gap-3 mb-4">
                                            <div className="p-2 bg-white rounded-xl border border-slate-200/60">
                                                <Globe size={18} className="text-orange-600" />
                                            </div>
                                            <div className="flex-1">
                                                <h4 className="font-bold text-lg text-slate-900">
                                                    {page.type}
                                                </h4>
                                                <div className="text-sm text-slate-600 font-medium">
                                                    Page #{index + 1}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="bg-white/80 rounded-xl p-4 border border-slate-200/60 mb-4">
                                            <div className="flex items-center gap-2 mb-2">
                                                <ExternalLink size={14} className="text-slate-600" />
                                                <span className="text-sm font-bold text-slate-700">URL</span>
                                            </div>
                                            <a
                                                href={page.url}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="text-sm font-medium hover:underline text-orange-600 hover:text-orange-700 transition-colors break-all"
                                            >
                                                {page.url}
                                            </a>
                                        </div>

                                        {page.lastChecked && (
                                            <div className="bg-white/80 rounded-xl p-4 border border-slate-200/60">
                                                <div className="flex items-center gap-2 mb-1">
                                                    <Calendar size={14} className="text-slate-600" />
                                                    <span className="text-sm font-bold text-slate-700">Last Checked</span>
                                                </div>
                                                <div className="text-sm text-slate-600 font-medium">
                                                    {new Date(page.lastChecked).toLocaleString()}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
